import React, { FunctionComponent } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { IFormTextAreaInputProps } from './types';

import { get } from 'lodash';

export const FormTextAreaInput: FunctionComponent<IFormTextAreaInputProps> = ({
  id,
  name,
  defaultValue,
  placeholder,
  validation,
  disabled,
  label,
  rows,
}) => {
  const { control, errors } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue || ''}
      rules={validation}
      render={(controllerProps) => (
        <>
          <div className="flex">
            {!!get(errors, name, false) && (
              <label htmlFor={name} style={{ color: 'red' }}>
                {`${label ? label + ' - ' : ''} ${get(errors, `${name}.message`)}`}
              </label>
            )}

            {!get(errors, name, false) && <label htmlFor={name}>{label}</label>}
          </div>
          <textarea
            id={id}
            name={name}
            placeholder={placeholder}
            disabled={disabled}
            rows={rows}
            onChange={controllerProps.onChange}
            value={controllerProps.value}
          />
        </>
      )}
    />
  );
};
